module.exports = __webpack_public_path__ + "static/running-4-8006aea9d146fb8ee6523cae377a2638.jpg";